<template>
  <section>
    <div class="row">
      <div v-if="boolIsYearlyPerformanceData" v-bind:class="getLayoutClass">
        <div class="table-header" v-html="blockData.header_year"></div>

        <table class="table performance-table print-hide">
          <thead>
            <tr v-if="blockData.equities === undefined || blockData.equities.length > 0">
              <th colspan="3" class="text-center">
                <select v-model="selectedPerformanceData">
                  <option :value="blockData.fund_data[0]">{{ fundName }}</option>
                  <option v-for="(equity, index) in blockData.equities"
                    :value="blockData.equities[index].standard_data[0]">{{ equity.name }}</option>
                </select>
              </th>
            </tr>
            <tr>
              <th class="performance-table_cell--period">Period</th>
              <th class="text-center">Return</th>
              <th v-if="hasBenchmark" class="text-center">Benchmark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in performanceAttributes.yearly.dataAttributes">
              <td>{{ fundData.standard[0][performanceAttributes.yearly.labelAttributes[index]] }}</td>
              <td>
                <transition name="slide-fade" mode="out-in">
                  <span :key="selectedPerformanceData[performanceAttributes.yearly.dataAttributes[index]]"
                    class="text-right">{{ selectedPerformanceData[performanceAttributes.yearly.dataAttributes[index]]
                    }}</span>
                </transition>
              </td>
              <td v-if="hasBenchmark"><span class="text-right">{{
                fundData.benchmark[0][performanceAttributes.yearly.dataAttributes[index]] }}</span></td>
            </tr>
          </tbody>
        </table>

        <table class="table performance-table print-show">
          <thead>
            <th>Period</th>
            <th>{{ fundName }}</th>
            <th v-for="(equity, index) in blockData.equities">{{ equity.name }}</th>
            <th v-if="hasBenchmark">Benchmark</th>
          </thead>
          <tbody>
            <tr v-for="(row, index) in performanceAttributes.yearly.dataAttributes">
              <td>{{ fundData.standard[0][performanceAttributes.yearly.labelAttributes[index]] }}</td>
              <td>{{ fundData.standard[0][performanceAttributes.yearly.dataAttributes[index]] }}</td>
              <td v-if="blockData.equities === undefined || blockData.equities.length > 0"
                v-for="(fund, n) in blockData.equities">
                <span class="text-right">{{
                  blockData.equities[n].standard_data[0][performanceAttributes.yearly.dataAttributes[index]] }}</span>
              </td>
              <td v-if="hasBenchmark">{{ fundData.benchmark[0][performanceAttributes.yearly.dataAttributes[index]] }}</td>
            </tr>
          </tbody>
        </table>

        <div class="table-footer" v-html="blockData.footer_year"></div>
      </div>

      <div v-bind:class="getLayoutClass">
        <div class="table-header" v-html="blockData.header_past"></div>

        <table class="table performance-table print-hide">
          <thead>
            <tr v-if="blockData.equities === undefined || blockData.equities.length > 0">
              <th v-if="hasBenchmark" colspan="3" class="text-center">
                <select v-model="selectedPerformanceData">
                  <option :value="blockData.fund_data[0]">{{ fundName }}</option>
                  <option v-for="(equity, index) in blockData.equities"
                    :value="blockData.equities[index].standard_data[0]">{{ equity.name }}</option>
                </select>
              </th>
            </tr>
            <tr>
              <th class="performance-table_cell--period">Period</th>
              <th class="text-center">Return</th>
              <th v-if="hasBenchmark" class="text-center">Benchmark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in performanceAttributes.annualised.dataAttributes">
              <td>{{ fundData.standard[0][performanceAttributes.annualised.labelAttributes[index]] }}</td>
              <td>
                <transition name="slide-fade" mode="out-in">
                  <span :key="selectedPerformanceData[performanceAttributes.annualised.dataAttributes[index]]"
                    class="text-right">{{ selectedPerformanceData[performanceAttributes.annualised.dataAttributes[index]]
                    }}</span>
                </transition>
              </td>
              <td v-if="hasBenchmark"><span class="text-right">{{
                fundData.benchmark[0][performanceAttributes.annualised.dataAttributes[index]] }}</span></td>
            </tr>
          </tbody>
        </table>

        <table class="table performance-table print-show">
          <thead>
            <th>Period</th>
            <th>{{ fundName }}</th>
            <th v-for="(equity, index) in blockData.equities">{{ equity.name }}</th>
            <th v-if="hasBenchmark">Benchmark</th>
          </thead>
          <tbody>
            <tr v-for="(row, index) in performanceAttributes.annualised.dataAttributes">
              <td>{{ fundData.standard[0][performanceAttributes.annualised.labelAttributes[index]] }}</td>
              <td>{{ fundData.standard[0][performanceAttributes.annualised.dataAttributes[index]] }}</td>
              <td v-if="blockData.equities === undefined || blockData.equities.length > 0"
                v-for="(fund, n) in blockData.equities">
                <span class="text-right">{{
                  blockData.equities[n].standard_data[0][performanceAttributes.annualised.dataAttributes[index]] }}</span>
              </td>
              <td v-if="hasBenchmark">{{ fundData.benchmark[0][performanceAttributes.annualised.dataAttributes[index]] }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="table-footer" v-html="blockData.footer_past"></div>
      </div>
    </div>

  </section>
</template>

<script>

import moment from 'moment';

export default {
  props: {
    fundName: String,
    asAtDate: String,
    fundData: Array,
    hasBenchmark: Boolean,
    blockData: Object
  },
  data: function () {
    return {
      selectedPerformanceData: this.blockData.fund_data[0],
      performanceData1: [],
      performanceData2: [],
      performanceAttributes: {
        yearly: {
          labelAttributes: ['year_one_label', 'year_two_label', 'year_three_label', 'year_four_label', 'year_five_label'],
          dataAttributes: ['year_one', 'year_two', 'year_three', 'year_four', 'year_five']
        },
        annualised: {
          labelAttributes: ['quarter_label', 'one_year_label', 'three_year_label', 'five_year_label'],
          dataAttributes: ['quarter', 'one_year', 'three_year', 'five_year']
        }
      }
    }
  },
  methods: {
    asAtMinus: function (years) {
      return moment(this.asAtDate).subtract(years, 'years').format('DD/MM/YYYY')
    },
    // getLayoutClass: function () {
    //   return {
    //     'col-12 block': this.hasBenchmark,
    //     'col-12 col-md-6 block no-benchmark': !this.hasBenchmark
    //   }
    // }
  },
  computed: {
    getLayoutClass: function () {
      return {
        'col-12 block': this.hasBenchmark,
        'col-12 col-md-6 block no-benchmark': !this.hasBenchmark
      }
    },
    boolIsYearlyPerformanceData: function () {
      return (this.fundData.standard[0].year_one != null ||
        this.fundData.standard[0].year_two != null ||
        this.fundData.standard[0].year_three != null ||
        this.fundData.standard[0].year_four != null ||
        this.fundData.standard[0].year_five != null);
      // if (this.fundData.standard[0].year_one == null &&
      //   this.fundData.standard[0].year_two == null &&
      //   this.fundData.standard[0].year_three == null &&
      //   this.fundData.standard[0].year_four == null &&
      //   this.fundData.standard[0].year_five == null) {
      //   return false;
      // } else {
      //   return true;
      // }
    }
  },
  created: function () {

    var myNewData = [];

    // Collates fund performance, equity performance and
    // benchmark data
    myNewData.push(this.blockData.fund_data[0])
    for (var i = 0; i < this.blockData.equities.length; i++) {
      myNewData.push(this.blockData.equities[i].standard_data[0]);
    }
    myNewData.push(this.blockData.fund_data[1])

    // Split data into an array for each 
    // of the two tables in output order
    for (var equityIndex = 0; equityIndex < myNewData.length; equityIndex++) {
      var equitySet1 = [];
      var equitySet2 = [];
      Object.keys(myNewData[equityIndex]).forEach(function (key, index) {
        var value = myNewData[equityIndex][key];
        if (index > 5) {
          equitySet1.unshift(value);
        }
        if (index > 1 && index < 6) {
          equitySet2.push(value);
        }
      });
      this.performanceData1.push(equitySet1);
      this.performanceData2.push(equitySet2);
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  margin-bottom: 1em;
}

select {
  color: black;
}

.table.performance-table {
  margin-bottom: 0;

  td span.text-right {
    display: block;
    padding-right: 40%;
  }

  .performance-table_cell--period {
    min-width: 40%;
  }
}

.no-benchmark {
  .table.performance-table {
    .performance-table_cell--period {
      min-width: 50%;
    }
  }
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  // transform: rotate(10deg);
  opacity: 0;
}

.table-header,
.table-footer {
  p {
    margin: 0;
  }
}
</style>
